import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./Register.css";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../Services/Api";

const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .matches(/^[A-Za-z]+$/, "Only letters allowed")
    .required("First Name is required"),
  last_name: Yup.string()
    .matches(/^[A-Za-z]+$/, "Only letters allowed")
    .required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  company: Yup.string().required("Company name is required"),
  username: Yup.string().required("Username is required"),
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  password: Yup.string().min(6, "Minimum 6 characters").required("Password is required"),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm your password"),
});

const CircleForm = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const initialValues = {
    first_name: "",
    last_name: "",
    fullname: "",
    email: "",
    phone: "",
    company: "",
    username: "",
    country: "",
    state: "",
    password: "",
    password_confirmation: "",
  };

 const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  try {
    const updatedValues = { ...values, fullname: `${values.first_name} ${values.last_name}` };
    const { data, status } = await postData("register", updatedValues);

    if (status === 409) {
      toast.error(data.message);
      return;
    } else if (status === 422) {
      Object.values(data.errors).forEach((messages) => {
        toast.error(messages[0]);
      });
      return;
    } else if (!data.status) {
      toast.error(data.message || "Something went wrong");
      return;
    }

    toast.success(data.message || "Registration successful!");
    resetForm();
    navigate("/login");

  } catch (err) {
    // Only real network errors end up here
    toast.error("Network error. Please try again.");
  } finally {
    setSubmitting(false);
  }
};


  return (
    <>
     <title>EDC - Register</title>
      <meta name="description" content="Browse professional courses to upskill yourself in technology, business, and more." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />
    <div className="main-login-flex">
      <div className="circle-form">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="flex justify-center ">
                <img src="/images/LSClogo.png" alt="Logo" className="h-20 w-auto" />
              </div>

              <h1 className="my-5"
                style={{
                  textAlign: "center",
                  color: "#5D4CCF",
                  fontWeight: "700",
                  fontSize: "25px",
                }}
              >
                Executive Development Center
              </h1>

              <div className="form-grid my-4">
                <div>
                  <Field
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    onKeyPress={(e) => {
                      if (!/^[A-Za-z]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <ErrorMessage name="first_name" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    onKeyPress={(e) => {
                      if (!/^[A-Za-z]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <ErrorMessage name="last_name" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field type="email" name="email" placeholder="Email" />
                  <ErrorMessage name="email" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    maxLength={10}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <ErrorMessage name="phone" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field type="text" name="company" placeholder="Company Name" />
                  <ErrorMessage name="company" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field type="text" name="username" placeholder="Username" />
                  <ErrorMessage name="username" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field
                    type="text"
                    name="country"
                    placeholder="Country"
                    onKeyPress={(e) => {
                      if (!/^[A-Za-z]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <ErrorMessage name="country" component="div" className="error" style={{ color: "red" }} />
                </div>

                <div>
                  <Field
                    type="text"
                    name="state"
                    placeholder="State"
                    onKeyPress={(e) => {
                      if (!/^[A-Za-z]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <ErrorMessage name="state" component="div" className="error" style={{ color: "red" }} />
                </div>

                {/* PASSWORD FIELD WITH EYE ICON */}
                <div style={{ position: "relative" }}>
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                  />
                  <i
                    className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "12px",
                      cursor: "pointer",
                      color: "#666",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  ></i>
                  <ErrorMessage name="password" component="div" className="error" style={{ color: "red" }} />
                </div>

                {/* CONFIRM PASSWORD WITH EYE ICON */}
                <div style={{ position: "relative" }}>
                  <Field
                    type={showConfirmPassword ? "text" : "password"}
                    name="password_confirmation"
                    placeholder="Confirm Password"
                  />
                  <i
                    className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "12px",
                      cursor: "pointer",
                      color: "#666",
                    }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  ></i>
                  <ErrorMessage name="password_confirmation" component="div" className="error" style={{ color: "red" }} />
                </div>
              </div>

              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Sign Up"}
              </button>

              <p className="m-1">
                Already Registered?
                <Link to="/login" className="mx-3" style={{ color: "#5D4CCF" }}>
                  Login
                </Link>
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </div>
    </>
  );
};

export default CircleForm;
